// IMPORTANT: Do NOT add static top-level imports for 'react-leaflet' or 'leaflet' here.
// Both packages access `window` during module initialisation which crashes Node during SSR.
// All leaflet code is loaded via dynamic import() inside useEffect (browser-only lifecycle).
import React, { useEffect, useState } from 'react';

// CenterMap is inlined here so it can receive the dynamically-loaded `useMap` hook.
const CenterMapInner = ({ markers, useMap }) => {
  const map = useMap();
  if (!markers || markers.length === 0) return null;
  const bounds = markers.map(d => d.latlng);
  map.fitBounds(bounds);
  return null;
};

const SafariMap = ({ destinations }) => {
  const [mapModules, setMapModules] = useState(null);

  useEffect(() => {
    Promise.all([
      import('react-leaflet'),
      import('leaflet/dist/leaflet.css'),
    ]).then(([reactLeaflet]) => {
      setMapModules(reactLeaflet);
    });
  }, []);

  if (!mapModules) return null;

  const { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } = mapModules;

  const inlineStyle = {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontSize: '17px',
    color: 'rgb(90, 97, 105)',
  };

  const renderMarkers = () =>
    destinations.map(marker => (
      <Marker position={marker.latlng} key={marker.id}>
        <Popup>
          <p style={inlineStyle}>{marker.name}</p>
        </Popup>
      </Marker>
    ));

  const renderPolyLine = () => {
    const latlngs = destinations.map(marker => marker.latlng);
    return (
      <Polyline
        positions={latlngs}
        weight="3"
        dashArray="6"
        dashOffset="6"
        color="#ff9233"
        fillOpacity="0.7"
      />
    );
  };

  return (
    <MapContainer
      center={[51.505, -0.09]}
      zoom={13}
      scrollWheelZoom={false}
      style={{ height: '100%' }}
      closePopupOnClick
    >
      <TileLayer
        attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
        url={`https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${import.meta.env.VITE_LEAFLET_APIKEY}`}
        zIndex={-1}
      />
      <CenterMapInner markers={destinations} useMap={useMap} />
      {renderMarkers()}
      {renderPolyLine()}
    </MapContainer>
  );
};

export default SafariMap;
